import type { Runtime } from '../types'
import type { RuntimeWebLaunchAvailability } from './webLaunch'

export function runtimeRelayLaunchAvailability(runtime: Runtime): RuntimeWebLaunchAvailability {
  if (runtime.presence === 'unknown' || runtime.readiness === 'unknown') return 'unverifiable'
  if (runtime.presence === 'degraded') return 'degraded'
  if (runtime.presence !== 'present' || runtime.status === 'offline') return 'offline'
  if (runtime.readiness !== 'ready') return runtime.readiness
  if (runtime.runtimeProtocolVersion !== 3) return 'version_incompatible'
  if (!runtime.connectionCapabilities?.includes('hive-relay')
    || !runtime.connectionCapabilities.includes('ticket-connect-v2')) return 'unavailable'
  return typeof runtime.resourceVersion === 'number'
    && Number.isSafeInteger(runtime.resourceVersion) && runtime.resourceVersion > 0
    ? 'available' : 'unverifiable'
}

export function runtimeRelayLaunchPath(runtime: Runtime): string {
  if (runtimeRelayLaunchAvailability(runtime) !== 'available'
    || !/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(runtime.id)) {
    throw new Error('Runtime unavailable')
  }
  return `/runtime/?runtime=${encodeURIComponent(runtime.id)}`
}
